import PocketBase from 'pocketbase';

const pb = new PocketBase('https://luniversdiag.infocolab.online');
pb.autoCancellation(false);

export default pb;
